import { Component } from '@angular/core';

@Component({
  selector: 'lib-notification-center',
  imports: [],
  templateUrl: './notification-center.component.html',
  styleUrl: './notification-center.component.scss',
})
export class NotificationCenterComponent {}
